/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Seeallgenres2Inputs */

const id_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat semua genre`)
};

const ms_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat semua genre`)
};

const da_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alle genrer`)
};

const de_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Genres ansehen`)
};

const en_us2_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all genres`)
};

const es_es2_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos los géneros`)
};

const es_mx2_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos los géneros`)
};

const fil_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan lahat ng genre`)
};

const fr_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir tous les genres`)
};

const it_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi tutti i generi`)
};

const hu_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes műfaj megtekintése`)
};

const nl_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk alle genres`)
};

const no_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alle sjangre`)
};

const pl_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz wszystkie gatunki`)
};

const pt_br2_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja todos os gêneros`)
};

const pt_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos os géneros`)
};

const ro_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi toate genurile`)
};

const fi_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katso kaikki lajityypit`)
};

const sv_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se alla genrer`)
};

const vi_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem tất cả thể loại`)
};

const tr_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm türleri gör`)
};

const cs_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit všechny žánry`)
};

const bg_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вижте всички жанрове`)
};

const ru_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть все жанры`)
};

const uk_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути всі жанри`)
};

const ar_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض جميع الأنواع`)
};

const hi_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी शैलियाँ देखें`)
};

const th_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูแนวเกมทั้งหมด`)
};

const ja_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのジャンルを見る`)
};

const zh_cn2_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看所有类型`)
};

const zh_hant1_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檢視所有類型`)
};

const ko_nav_seeallgenres2 = /** @type {(inputs: Nav_Seeallgenres2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 장르 보기`)
};

/**
* | output |
* | --- |
* | "See all genres" |
*
* @param {Nav_Seeallgenres2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_seeallgenres2 = /** @type {((inputs?: Nav_Seeallgenres2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Seeallgenres2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_seeallgenres2(inputs)
	if (locale === "ms") return ms_nav_seeallgenres2(inputs)
	if (locale === "da") return da_nav_seeallgenres2(inputs)
	if (locale === "de") return de_nav_seeallgenres2(inputs)
	if (locale === "en-US") return en_us2_nav_seeallgenres2(inputs)
	if (locale === "es-ES") return es_es2_nav_seeallgenres2(inputs)
	if (locale === "es-MX") return es_mx2_nav_seeallgenres2(inputs)
	if (locale === "fil") return fil_nav_seeallgenres2(inputs)
	if (locale === "fr") return fr_nav_seeallgenres2(inputs)
	if (locale === "it") return it_nav_seeallgenres2(inputs)
	if (locale === "hu") return hu_nav_seeallgenres2(inputs)
	if (locale === "nl") return nl_nav_seeallgenres2(inputs)
	if (locale === "no") return no_nav_seeallgenres2(inputs)
	if (locale === "pl") return pl_nav_seeallgenres2(inputs)
	if (locale === "pt-BR") return pt_br2_nav_seeallgenres2(inputs)
	if (locale === "pt") return pt_nav_seeallgenres2(inputs)
	if (locale === "ro") return ro_nav_seeallgenres2(inputs)
	if (locale === "fi") return fi_nav_seeallgenres2(inputs)
	if (locale === "sv") return sv_nav_seeallgenres2(inputs)
	if (locale === "vi") return vi_nav_seeallgenres2(inputs)
	if (locale === "tr") return tr_nav_seeallgenres2(inputs)
	if (locale === "cs") return cs_nav_seeallgenres2(inputs)
	if (locale === "bg") return bg_nav_seeallgenres2(inputs)
	if (locale === "ru") return ru_nav_seeallgenres2(inputs)
	if (locale === "uk") return uk_nav_seeallgenres2(inputs)
	if (locale === "ar") return ar_nav_seeallgenres2(inputs)
	if (locale === "hi") return hi_nav_seeallgenres2(inputs)
	if (locale === "th") return th_nav_seeallgenres2(inputs)
	if (locale === "ja") return ja_nav_seeallgenres2(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_seeallgenres2(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_seeallgenres2(inputs)
	return ko_nav_seeallgenres2(inputs)
});
export { nav_seeallgenres2 as "nav.seeAllGenres" }